export const customTags = [
  'App',
  'Dashboard',
  'File',
  'Notification',
  'Report',
  'SlackInstallations',
  'SlackConversation',
  'TelegramConfig',
  'TelegramConversation',
  'CommsTemplates',
  'CommsQueueAliases',
  'SuperAdminAgents',
  'AgentApiKeys',
  'EditorialDesk',
  'AgentCmsSettings',
  'GrowthAgentSettings',
];
